import { GetServerSidePropsContext, NextPage } from "next";
import InterestMainPage from "components/pages/interest/Index";
import { getServerSession } from "next-auth/next";
import { authOptions } from "pages/api/auth/[...nextauth]";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Session } from "interfaces/login";

interface Props {
  isMobile: boolean;
  session: Session;
}

const Interest: NextPage<Props> = ({ isMobile, session }) => {
  return <InterestMainPage isMobile={isMobile} />;
};

export default Interest;

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  let locale = ctx.locale || ctx.defaultLocale;
  const session: Session | null = await getServerSession(
    ctx.req,
    ctx.res,
    authOptions
  );

  return {
    props: {
      session,
      ...(await serverSideTranslations(locale as string, ["watchlist"])),
    },
  };
}
